import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Tambah Cabang")
  ])
], -1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Bank", -1)
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Area", -1)
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Pilih Area", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nama Cabang", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Penanggung Jawab", -1)
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-6 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Email", -1)
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "col-lg-6 fv-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_35 = { class: "fv-plugins-message-container" }
const _hoisted_36 = { class: "fv-help-block" }
const _hoisted_37 = { class: "row fv-row mb-7" }
const _hoisted_38 = { class: "col-xl-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Provinsi", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Provinsi Dahulu", -1)
const _hoisted_41 = ["label", "value"]
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-xl-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kabupaten", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Kabupaten/ Kota", -1)
const _hoisted_47 = ["label", "value"]
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row fv-row mb-7" }
const _hoisted_51 = { class: "col-xl-6" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kecamatan", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Kecamatan", -1)
const _hoisted_54 = ["label", "value"]
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "col-xl-6" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Alamat", -1)
const _hoisted_59 = { class: "fv-plugins-message-container" }
const _hoisted_60 = { class: "fv-help-block" }
const _hoisted_61 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_62 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.tambahBranchValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.onlyId.idBank,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.onlyId.idBank) = $event)),
                    placeholder: "Pilih Bank Terlebih Dahulu",
                    mode: "single",
                    "create-option": false,
                    options: _ctx.items.listBank,
                    searchable: true,
                    label: "name",
                    "track-by": "name",
                    "value-prop": "_id",
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getListArea($event)))
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "name" })
                    ])
                  ])
                ]),
                (_ctx.cekArea.cekArea)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.onlyId.idArea,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onlyId.idArea) = $event)),
                        name: "idArea",
                        placeholder: "Pilih Area",
                        mode: "single",
                        "create-option": false,
                        options: _ctx.items.listArea,
                        searchable: true,
                        label: "areaName",
                        "track-by": "areaName",
                        "value-prop": "areaId"
                      }, null, 8, ["modelValue", "options"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "picBranch" })
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        class: "form-control form-control-lg",
                        placeholder: "Pilih Area",
                        disabled: ""
                      }),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_ErrorMessage, { name: "picBranch" })
                        ])
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "name",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nama Cabang",
                    modelValue: _ctx.tambahBranch.name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tambahBranch.name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_ErrorMessage, { name: "name" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "picBranch",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Penanggung Jawab",
                    modelValue: _ctx.tambahBranch.picBranch,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahBranch.picBranch) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ErrorMessage, { name: "picBranch" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "email",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Email",
                    modelValue: _ctx.tambahBranch.email,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tambahBranch.email) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "phone",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Nomor Telepon",
                    modelValue: _ctx.tambahBranch.phone,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tambahBranch.phone) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "province",
                    autocomplete: "off",
                    modelValue: _ctx.tambahBranch.address.province,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tambahBranch.address.province) = $event)),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getKabupaten()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_40,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.provinsiOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.name
                        }, null, 8, _hoisted_41))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_ErrorMessage, { name: "province" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "city",
                    autocomplete: "off",
                    modelValue: _ctx.tambahBranch.address.city,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tambahBranch.address.city) = $event)),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getKecamatan()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_46,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kabupatenOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.name
                        }, null, 8, _hoisted_47))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_ErrorMessage, { name: "city" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "regency",
                    autocomplete: "off",
                    modelValue: _ctx.tambahBranch.address.regency,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tambahBranch.address.regency) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_53,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kecamatanOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.name
                        }, null, 8, _hoisted_54))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_ErrorMessage, { name: "regency" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control form-control-lg",
                    type: "text",
                    placeholder: "",
                    name: "detail",
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.tambahBranch.address.detail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.tambahBranch.address.detail]
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_ErrorMessage, { name: "detail" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("button", {
                class: "btn btn-danger me-3",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/superadmin/branch')))
              }, " Batal "),
              _createElementVNode("button", _hoisted_62, _hoisted_65, 512)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ])
  ], 64))
}